import { Component, OnInit, OnChanges, Input, OnDestroy } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-form-token-length-card',
  templateUrl: './turns-form-token-length-card.component.html',
  styleUrls: ['./turns-form-token-length-card.component.scss']
})
export class TurnsFormTokenLengthCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;
  basicDataForm = new FormGroup({
    tokenLength: new FormControl(null, Validators.required)
  });
  updateFormTokenLengthSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public submitForm() {
    this.updateFormTokenLengthSubscription = this.formsTurnsService.updateFormTokenLength(this.form.InternalId, this.basicDataForm.get('tokenLength').value).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      tokenLength: this.form.AppointmentTokenLength
    });
  }

  ngOnDestroy() {
    if (this.updateFormTokenLengthSubscription) { this.updateFormTokenLengthSubscription.unsubscribe(); }
  }

}
